'use strict';
const angular = require('angular');

export default angular.module('conduuApp.htmliframe', [])
  .directive('htmlIframe', function() {
    return {
      restrict: 'E',
      scope: {
        content: "<"
      },
      link: function(scope, element, attrs) {

        var iframe = document.createElement('iframe');
        var element0 = element[0];
        element0.appendChild(iframe);

        scope.$watch('content', function () {
          iframe.contentWindow.document.open('text/htmlreplace');
          iframe.contentWindow.document.write(scope.content);
          iframe.contentWindow.document.close();
        });


/*
        var iframe = document.createElement('iframe');
        var element0 = element[0];
        element0.appendChild(iframe);
        var body = iframe.contentDocument.body;

        console.log(element0);

        scope.$watch('content', function () {
          body.innerHTML = scope.content;
        });  */
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/html-iframe/html-iframe.directive.js